export default function getDataFetchingClientStatus(errorState) {
  if (errorState && errorState.networkError && errorState.networkError.statusCode) {
    if (errorState.networkError.statusCode === 403) {
      return 403;
    } else if (errorState.networkError.statusCode === 404) {
      return 404;
    }
  }

  return null;
}